import { PropsWithChildren, createContext, use, useState } from "react";

export default function UploadDialogProvider(p: PropsWithChildren) {
  const value = useProvider();
  return <UploadDialogContext value={value}>{p.children}</UploadDialogContext>;
}

export function useUploadDialog() {
  return use(UploadDialogContext);
}

const UploadDialogContext = createContext<ReturnType<typeof useProvider>>(null);

function useProvider() {
  const [isOpen, setOpen] = useState(false);

  return {
    isOpen,
    close() {
      setOpen(false);
    },
    open() {
      setOpen(true);
    },
  };
}
